import React, { useState, useEffect, useCallback } from "react";
import { useApp } from "../../context/AppContext";
import * as api from "../../lib/api";
import { toast } from "sonner";
import { MovementsList } from "../printers/MovementsList";
import { MOVEMENT_KINDS } from "../printers/constants";

export default function PrinterJournalView({ printers, onChanged, refreshKey }) {
    const { hasPermission } = useApp();
    const [movements, setMovements] = useState(null);
    const [kind, setKind] = useState("");
    const [printerFilter, setPrinterFilter] = useState("");

    const load = useCallback(async () => {
        try {
            const params = {};
            if (kind) params.kind = kind;
            if (printerFilter) params.printer_id = printerFilter;
            const r = await api.getPrinterMovements(params);
            setMovements(r.movements);
        } catch { toast.error("Erreur de chargement"); }
    }, [kind, printerFilter]);

    useEffect(() => { load(); }, [load, refreshKey]);

    const deleteMovement = async (m) => {
        if (!window.confirm("Annuler ce mouvement ? Le stock sera recalculé.")) return;
        try { await api.deletePrinterMovement(m.id); toast.success("Mouvement annulé"); load(); onChanged(); }
        catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    };

    return (
        <div data-testid="journal-view">
            <div className="flex flex-wrap items-center gap-3 mb-4">
                <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
                    <button onClick={() => setKind("")} className={`px-3 py-1.5 text-xs font-medium rounded-md ${kind === "" ? "bg-white text-teal-700 shadow-sm" : "text-gray-500"}`} data-testid="journal-kind-all">Tous</button>
                    {Object.entries(MOVEMENT_KINDS).map(([k, v]) => (
                        <button key={k} onClick={() => setKind(k)} className={`px-3 py-1.5 text-xs font-medium rounded-md ${kind === k ? "bg-white text-teal-700 shadow-sm" : "text-gray-500"}`} data-testid={`journal-kind-${k}`}>{v.label}s</button>
                    ))}
                </div>
                <select value={printerFilter} onChange={(e) => setPrinterFilter(e.target.value)} className="px-3 py-2 text-sm border rounded-md bg-white max-w-[240px]" data-testid="journal-printer-filter">
                    <option value="">Toutes imprimantes</option>
                    {printers.map((p) => <option key={p.id} value={p.id}>{p.name}{p.site_name ? ` · ${p.site_name}` : ""}</option>)}
                </select>
                {movements && <span className="text-xs text-gray-400 ml-auto">{movements.length} mouvement(s)</span>}
            </div>
            <div className="card">
                <div className="card-body py-1 px-4">
                    {!movements ? <p className="text-xs text-gray-400 py-6 text-center animate-pulse">Chargement...</p>
                        : <MovementsList movements={movements} onDelete={hasPermission("admin") ? deleteMovement : undefined} emptyText="Aucun mouvement de stock enregistré" />}
                </div>
            </div>
        </div>
    );
}
